// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundOutlinedSvg from "@ant-design/icons-svg/es/asn/SoundOutlined";
import AntdIcon from '../components/AntdIcon';

var SoundOutlined = function SoundOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundOutlinedSvg
  }));
};

SoundOutlined.displayName = 'SoundOutlined';
export default React.forwardRef(SoundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SoundOutlined.js
// module id = 1857
// module chunks = 0